import { ReactNode } from "react";
import styled, { css } from "styled-components";

export const Item = styled.li<{ isActive?: boolean; children?: ReactNode }>`
  position: relative;
  display: flex;
  flex-direction: column;

  ${({ isActive }) =>
    isActive &&
    css`
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        z-index: 1;
        background-color: var(--fd-colors-border-active);
      }
    `}
`;

export const Button = styled.button<{
  isResulted: boolean;
  hasBorderBottom: boolean;
  children?: ReactNode;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  height: 48px;
  padding: 0 ${({ theme }) => theme.space["space-5"]};
  ${({ hasBorderBottom, theme }) =>
    hasBorderBottom &&
    css`
      border-bottom: 1px solid ${theme.colorTokens.border.default};
    `}
  ${({ isResulted, theme }) =>
    isResulted &&
    css`
      background-color: ${theme.colorTokens.background.base};
    `}

  #race-track-name-wagerpad {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: ${({ theme }) => theme.space["space-2"]};
  }

  background-color: ${({ theme }) => theme.colorTokens.background.surface};

  &:hover {
    background-color: ${({ theme }) => theme.colorTokens.background.hover};
  }
`;

export const MTPContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: ${({ theme }) => theme.space["space-3"]};
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-right: ${({ theme }) => theme.space["space-3"]};
`;

export const FlagContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  height: 16px;
  width: 16px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: ${({ theme }) => theme.space["space-3"]};

  & > svg {
    height: 16px;
    width: auto;
    flex-shrink: 0;
  }

  &:is(:empty) {
    display: none;
  }
`;
